import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import { IActionType } from "../../interfaces/Index";
import { multiPartUploadApiCall } from "../sources/GlobalProductSource";

export const storeListingBulkUploadInit = () => ({
  type: actionTypes.BULK_UPLOAD_INIT,
});

export const storeListingBulkUploadSuccess = () => ({
  type: actionTypes.BULK_UPLOAD_SUCCESS,
});

export const storeListingBulkUploadFail = (error: string | object | null) => ({
  type: actionTypes.BULK_UPLOAD_FAIL,
  error,
});

// async actions

export const bulkUploadStoreListing = (payload: FormData, url: string) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(storeListingBulkUploadInit());
  return multiPartUploadApiCall(payload, url)
    .then(() => dispatch(storeListingBulkUploadSuccess()))
    .catch((e: object | null | string) =>
      dispatch(storeListingBulkUploadFail(e))
    );
};
